import { AgmMap, AgmMarker } from '@agm/core';
import { AgmSnazzyInfoWindow } from '@agm/snazzy-info-window';
import { Component, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { config } from '../../../../config/config';
import { CustomDefaultPlaceCategory, VisitorCalendarActionCommand } from '../../../commands/pagination.query.command';
import { AllFrontendSettingsCommand } from '../../../commands/visitor/all.frontend.settings.command';
import { BaseComponent } from '../../../common/components/base.component';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { PlaceCategory } from '../../../common/constants/constant';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { GoogleMapsService } from '../../../common/services/google.maps.service';
import { HubPlace } from '../../../models/hub/hub.place';
import { HubVisitorFeatureToggle, HubVisitorToggleDataSource } from '../../../models/hub/hub.visitor.feature.toggle';
import { ConfigService } from '../../../services/config.service';
import { GeoService } from '../../../services/geo.service';
import { ImageService } from '../../../services/image.service';
import { PlaceService } from '../../../services/place.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import {
  AllFrontendSettingsStore,
  VisitorCalendarStore,
  VisitorDataCache,
  VisitorStyleStore,
} from '../../../stores/visitor.calendar.store';
import { HubVisitorDataSource } from '../../../models/hub/hub.visitor.data.source';
import { PlaceDetailsModalActions } from '../place.details.modal/place.details.modal.provider';
import { ButtonTriggerEvent } from '../../../common/components';
import { PlaceDetailsModalComponent } from '../place.details.modal/place.details.modal.component';
import { ModalService } from '../../../common/services/modal.service';
import { TripDetailModalActions, TripDetailModalData } from '../trip/trip.detail.modal/trip.detail.modal.provider';
import { TripDetailModalComponent } from '../trip/trip.detail.modal/trip.detail.modal.component';
import { CustomDefaultPlaceCategoryItemSelectionStore } from '../../../stores/hub.calendar.store';
import { PlaceType } from '../../hub/place.category/customize.place.category.component';
import { MatSidenav } from '@angular/material/sidenav';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import {
  CustomDefaultPlaceCategoryAccordionComponent
} from '../../hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component.';
import { clone } from 'common/extensions';
import { CustomPlaceBtnComponent } from '../custom.place.btn/custom.place.btn.component';
import { isJsonString } from '../../../utils/common';
import { CustomizationApiService } from '../../../services/customization.api.service';

@Component({
  selector: 'ig-place-map',
  templateUrl: './visitor.place.map.component.html',
  styleUrls: [
    './visitor.place.map.component.scss',
    '../../../../node_modules/snazzy-info-window/dist/snazzy-info-window.css',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorPlaceMapComponent extends BaseComponent implements OnInit {
  public lat: number = ConfigService.config.google.USCenter.lat;
  public lng: number = ConfigService.config.google.USCenter.lng;
  public places: HubPlace[];
  public allPlaces: HubPlace[];
  public paginationIndex = 0;
  public paginationPageLimit = 20;
  public noMoreNext = false;
  public noMoreBack = true;
  public showingCount: string;
  public category = 'All';
  public categoryId = '';
  public place: HubPlace;
  public hubName: string;
  public menuType: string;
  public actionCommand = new VisitorCalendarActionCommand();
  public latLngBounds: any;
  public currentIndex: any;
  public showGroupInfowWindow = false;
  public canMarkerMouseOver = true;
  public isInfoWindowsOpen = [];
  public markerOverlappings: any[][];
  public groupPlaces: HubPlace[];
  public groupLat = 0;
  public groupLng = 0;
  public isLoading = false;
  public isInitLoading = false;
  public toggleAndSource = new HubVisitorToggleDataSource();
  public iconUrl = ConfigService.config.google.iconUrl;
  public hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;
  public isSideBarOpened = false;
  public isNeedSideEventList = false;
  public isMapFullSize = false;
  public simpleMenu = false;
  public isHideEditorChoice = false;
  public loadingToggles = false;
  public featuresToggle = new HubVisitorFeatureToggle();
  public dataSource = new HubVisitorDataSource();
  public customDefaultPlaceCategory = new CustomDefaultPlaceCategory();
  public initialCustomDefaultPlaceCategory: {
    categoryList: string[];
    categoryString: string;
    category: PlaceType;
  };
  public customPlaces;
  @ViewChild(AgmMap) public map: AgmMap;
  @ViewChild('sideBar') public sideBar: MatSidenav;
  @ViewChild('customDefaultPlaceAccordion')
  public customDefaultPlaceAccordion: CustomDefaultPlaceCategoryAccordionComponent;
  @ViewChildren(AgmSnazzyInfoWindow) snazzyWindowChildren: QueryList<AgmSnazzyInfoWindow>;
  @ViewChildren(AgmMarker) mapMarkers: QueryList<AgmMarker>;
  @ViewChild(PageSpinnerComponent) public spinner: PageSpinnerComponent;
  @ViewChildren(CustomPlaceBtnComponent) public customPlaceBtns: QueryList<CustomPlaceBtnComponent>;
  public placeMapIcon = {
    Accommodations: config.tripPlanner.placeMapIcon.accommodation,
    'Dining & Nightlife': config.tripPlanner.placeMapIcon.dinging,
    Activities: config.tripPlanner.placeMapIcon.activity,
    Shopping: config.tripPlanner.placeMapIcon.shopping,
    'Outdoors & Fitness': config.tripPlanner.placeMapIcon.outdoor,
    Entertainment: config.tripPlanner.placeMapIcon.entertainment,
    Transportation: config.tripPlanner.placeMapIcon.transportation,
    Other: config.tripPlanner.placeMapIcon.other,
    Event: config.tripPlanner.eventMapIcon,
  };

  constructor(
    private router: Router,
    private visitorApiService: VisitorApiService,
    private googleMapService: GoogleMapsService,
    private imageService: ImageService,
    private modalService: ModalService,
    private customDefaultPlaceCategoryItemSelectionStore: CustomDefaultPlaceCategoryItemSelectionStore,
    private visitorCalendarStore: VisitorCalendarStore,
    private visitorStyleStore: VisitorStyleStore,
    private allFrontendSettingsStore: AllFrontendSettingsStore,
    private customizationApiService: CustomizationApiService,
    private activatedRoute: ActivatedRoute
  ) {
    super({activatedRoute});
  }

  public ngOnInit() {
    let {hubName, category, menuType} = this.allRouteParams;
    this.hubName = hubName;
    this.category = category;
    this.categoryId = this.category;
    this.menuType = menuType;
    this.actionCommand.isMapView = true;
    this.actionCommand.queryCommand.category = category;
    this.actionCommand.queryCommand.isForMapView = true;
    // this.visitorCalendarStore.actionCommand.next(this.actionCommand);

    this.simpleMenu = menuType === 'simple';

    this.loadingToggles = true;
    this.allFrontendSettingsStore.allFrontendSettingsCommand
      .takeUntil(this.isDestroyed)
      .subscribe((command: AllFrontendSettingsCommand) => {
        if (command.toggle) {
          this.featuresToggle = command.toggle;
          this.dataSource = command.dataSource;
          if (this.isAllPlaceCategoriesTurnedOff) {
            this.featuresToggle.placeCalendar = false;
          }
          this.toggleAndSource.toggle = this.featuresToggle;
          this.loadingToggles = false;
        }
        if (command.dataSource) {
          this.toggleAndSource.dataSource = command.dataSource;
        }
        if (command.customSettings) {
          // map view for custom place btn
          if (this.category === 'custom-places') {
            this.setForCustomPlaceBtn(command);
          } else {
            // custom means now visiting a custom default place category, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
            // this needs to set the place category dropdown menu to only show that category
            if (this.menuType !== 'custom') {
              this.customDefaultPlaceCategory = command.customSettings.customDefaultPlaceCategory;
            }

            this.setCustomDefaultPlaceCategory(command.customSettings.customDefaultPlaceCategory);
            this.getSelectedCategoryFromCalendar();
          }
        }
      });
  }

  private setForCustomPlaceBtn(command) {
    this.spinner.show();
    this.category = 'All';
    this.customizationApiService.getCustomEvent(this.hubName).subscribe((custom) => {
      this.customPlaces = custom.customPlaces;
      let customBtn = custom.customPlaces.first((x) => x._id.toString() === this.menuType);
      if (customBtn) {
        this.customPlaceBtns.toArray().forEach((x) => {
          x.setFilter(customBtn.btnText);
        });

        this.actionCommand.queryCommand.isCustom = true;
        this.actionCommand.queryCommand.type = this.menuType;
        this.actionCommand.queryCommand.selectedPlaces = undefined;
        this.actionCommand.queryCommand.limit = config.placeSearchLimit;
        this.visitorApiService.getPlaces(this.hubName, this.actionCommand.queryCommand).subscribe((data) => {
          this.customDefaultPlaceCategory = command.customSettings.customDefaultPlaceCategory;
          this.afterGotPlaces(data);
        });
      } else {
        alert('Wrong custom place button Id, please check!');
        this.spinner.hide();
      }
    });
  }

  /**
   * if visit a custom default place category url, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
   * */
  private setCustomDefaultPlaceCategory(customDefaultPlaceCategory) {
    if (this.menuType === 'custom') {
      // this.category is the custom default place category id, e.g., 62a46ea3e6ad6016f05245ff
      const data = PlaceService.getCustomDefaultCategoryFromURL(this.category, customDefaultPlaceCategory);
      if (data) {
        this.categoryId = this.category;
        this.category = data.category.title;
        this.customDefaultPlaceCategory = customDefaultPlaceCategory;
        // this.customDefaultPlaceCategory = data.customDefaultPlaceCategory;
        // this.command.queryCommand.categoryList = data.categoryList;
        // const categoryString = JSON.stringify(data.category);
        this.initialCustomDefaultPlaceCategory = {
          category: data.category,
          categoryString: '',
          categoryList: data.categoryList,
        };
        // for map view
        // localStorage.setItem(localStorageKeys.selectedPlaceCategory, categoryString);
      }
    } else {
      this.customDefaultPlaceCategory = customDefaultPlaceCategory;
    }
    // this.visitorCalendarStore.actionCommand.next(this.command);
  }

  public getSelectedCategoryFromCalendar() {
    // get selected category from calendar and use
    const selectedPlaceCategoryStr = localStorage.getItem(localStorageKeys.selectedPlaceCategory);
    this.setCustomDefaultPlaceCategoryFilter();
    this.clearCustomBtnFilter();
    console.log('selectedPlaceCategoryStr', selectedPlaceCategoryStr);

    if (!selectedPlaceCategoryStr) {
      return this.getPlaces('All');
    }

    const selectedCustomPlaceCategory = isJsonString(selectedPlaceCategoryStr)
      ? JSON.parse(selectedPlaceCategoryStr)
      : selectedPlaceCategoryStr;
    console.log('selectedCustomPlaceCategory', selectedCustomPlaceCategory);

    // string: selected an IG default place category, otherwise it is a customized category, need to load its categoryList
    if (typeof selectedCustomPlaceCategory === 'string') {
      if (this.menuType === 'custom') {
        const place = PlaceService.getCustomDefaultPlaceCategoryById(
          selectedCustomPlaceCategory,
          this.customDefaultPlaceCategory
        );
        console.log('place...', place);

        this.getPlaces(this.category, place);
      } else {
        this.getPlaces(selectedCustomPlaceCategory);
      }
    } else {
      setTimeout(() => {
        // has 'actionCommand' and 'customBtnText' means it is a custom place button (see getFeedPlace function in custom.place.btn.component.ts), otherwise it is a custom default place category
        if (selectedCustomPlaceCategory && selectedCustomPlaceCategory['queryCommand']) {
          this.actionCommand = selectedCustomPlaceCategory;
          this.setCustomBtnFilter();
          this.getPlaces(this.category);
        } else {
          this.getPlaces(this.category, selectedCustomPlaceCategory);
        }
      });
    }
  }

  // CustomDefaultPlaceCategoryAccordionComponent.clearFilter has problem here, so temporarily use this method
  public setCustomDefaultPlaceCategoryFilter(title?: string) {
    // setTimeout(() => {
    if (this.customDefaultPlaceAccordion) {
      const customDefaultPlaceCategoryTitleSpans = document.querySelectorAll(
        '#place-map-custom-default-category'
      );
      if (customDefaultPlaceCategoryTitleSpans) {
        Array.from(customDefaultPlaceCategoryTitleSpans).forEach((x) => {
          const span = x.querySelector('span');
          span && (span.innerHTML = title || 'FILTER BY CATEGORY');
        });

        if (!title) {
          const levels = document.querySelectorAll('.category-level span');
          Array.from(levels).forEach((x) => {
            (x as HTMLElement).style.fontWeight = 'normal';
            (x as HTMLElement).style.color = 'rgba(0, 0, 0, 0.87)';
          });
        }
      }
    }
    // });
  }

  public clearCustomBtnFilter() {
    this.customPlaceBtns &&
    this.customPlaceBtns.toArray().forEach((x) => {
      x.clearFilter();
    });
  }

  public setCustomBtnFilter() {
    this.customPlaceBtns.toArray().forEach((x) => {
      x.setFilter(this.actionCommand.queryCommand.customPlaceBtnText, this.actionCommand.queryCommand.choice);
    });
  }

  public customPlaceBtnSelected(command: VisitorCalendarActionCommand) {
    console.log('command from event', command);

    this.actionCommand = clone(command);
    this.getPlaces(null);
    this.setCustomDefaultPlaceCategoryFilter();
  }

  private get isAllPlaceCategoriesTurnedOff() {
    return PlaceService.isAllCategoriesTurnedOff(this.featuresToggle.placeCategory);
  }

  public filterPlace(category: string) {
    this.actionCommand.queryCommand.categoryList = null;
    this.actionCommand.queryCommand.selectedPlaces = null;
    this.actionCommand.queryCommand.isCustom = null;
    this.actionCommand.queryCommand.customPlaceBtnText = null;
    let selectedCustomPlaceCategory = null;
    if (this.menuType === 'custom' && category.toLowerCase() === 'all') {
      selectedCustomPlaceCategory = this.initialCustomDefaultPlaceCategory.category;
    }
    this.getPlaces(category, selectedCustomPlaceCategory);
  }

  public selectCustomDefaultPlaceCategory($event: PlaceType) {
    this.category = $event.title;

    this.actionCommand.isEventCalendar = false;
    this.actionCommand.queryCommand.feedId = null;
    this.actionCommand.queryCommand.category = $event.title;
    this.actionCommand.queryCommand.categoryList = $event.categoryList;
    this.actionCommand.queryCommand.selectedPlaces = null;
    this.actionCommand.queryCommand.isCustom = null;
    this.actionCommand.queryCommand.search = '';
    this.actionCommand.queryCommand.customPlaceBtnText = null;
    localStorage.setItem(
      localStorageKeys.selectedPlaceCategory,
      JSON.stringify({
        title: $event.title,
        categoryList: $event.categoryList,
      })
    );

    this.sideBar.close();

    this.visitorApiService.getPlaces(this.hubName, this.actionCommand.queryCommand).subscribe((data) => {
      this.afterGotPlaces(data);
    });

    this.setCustomDefaultPlaceCategoryFilter(this.category);
  }

  public isSelected(title: string) {
    return this.actionCommand.queryCommand.category === title;
  }

  public getPlaces(category: string, selectedCustomPlaceCategory?: PlaceType) {
    if (selectedCustomPlaceCategory) {
      // selected custom default place category
      this.isLoading = true;
      this.spinner.show();
      let categoryList = selectedCustomPlaceCategory.categoryList;
      if (!categoryList || !categoryList.length) {
        PlaceService.getAllSubCategories(selectedCustomPlaceCategory, categoryList);
      }
      this.category = selectedCustomPlaceCategory.title;
      this.getPlaceByPage(1, category, categoryList);
    } else {
      this.category = category || 'All';
      this.isLoading = true;

      this.actionCommand.queryCommand.limit = config.placeSearchLimit;
      this.actionCommand.queryCommand.category = category;
      this.spinner.show();
      this.visitorApiService.getPlaces(this.hubName, this.actionCommand.queryCommand).subscribe((data) => {
        this.afterGotPlaces(data);
      });
    }
  }

  public getPlaceByPage(page: number, category: string, categoryList?: string[]) {
    this.visitorApiService
      .getPlaces(this.hubName, {
        limit: 1000,
        page: page,
        category: category,
        categoryList: categoryList ? categoryList.join(',') : null,
        source: this.dataSource.place,
        isForMapView: true,
      })
      .subscribe((data) => {
        if (category.toLowerCase() === 'all') {
          this.getPlaceCategories().subscribe((placeCategories) => {
            for (let place of data) {
              for (let key in placeCategories) {
                if (place.categoryList.any((x) => placeCategories[key].any((y) => x === y))) {
                  place.mapIcon = key;
                  break;
                } else {
                  // console.log('not in: ' + place.categoryList.join(', '));
                }
              }
            }
            this.afterGotPlaces(data);
          });
        } else {
          for (let place of data) {
            place.mapIcon = category;
          }
          this.afterGotPlaces(data);
        }

        // change URL for an IG default category selected
        if (!categoryList) {
          this.router.navigateByUrl(
            getRouteUrl(routeConfigs.visitor.placeMap, {
              hubName: this.hubName,
              category: PlaceCategory.getPlaceCategoryKey(category),
              menuType: this.simpleMenu ? 'simple' : 'normal',
            }),
            {skipLocationChange: this.noChangeUrlWhenRedirect}
          );
        }
      });
  }

  public showInfoWindowOnMarker(index: number) {
    if (!this.canMarkerMouseOver) {
      return;
    }

    let overlapGroup = [];
    this.markerOverlappings.forEach((x) => {
      if (x.any((y) => y === index)) {
        overlapGroup = x;
      }
    });

    if (overlapGroup.length) {
      console.log(
        overlapGroup.map((x) => {
          return x;
        })
      );

      this.groupPlaces = [];
      let lat = 0;
      let lng = 0;

      overlapGroup.forEach((x) => {
        this.groupPlaces.push(this.places[x]);
        let marker = this.mapMarkers.find((m, i) => {
          return i === x;
        });
        lat += marker.latitude;
        lng += marker.longitude;
      });

      this.groupLat = lat / overlapGroup.length;
      this.groupLng = lng / overlapGroup.length;

      this.hideAllSingleInfoWindow();
      this.showGroupInfowWindow = true;
    } else {
      this.showInfoWindowByIndex(index);
    }
  }

  public showInfoWindowByIndex(index: number) {
    this.hideAllSingleInfoWindow();
    this.currentIndex = index;

    setTimeout(() => {
      this.isInfoWindowsOpen[index] = true;
      this.showGroupInfowWindow = false;
    });
  }

  public groupInfoWindowCloses() {
    this.showGroupInfowWindow = false;
  }

  public mapZoomChange() {
    this.organizeMarkersForOverlapping();
    this.hideAllInfoWindow();
  }

  public removeDisplayInfoWindow() {
    this.canMarkerMouseOver = false;
  }

  public addDisplayInfoWindow() {
    setTimeout(() => {
      this.canMarkerMouseOver = true;
    }, 200);
  }

  public back() {
    this.actionCommand.queryCommand.category = this.category;
    this.category = PlaceCategory.getPlaceCategoryKey(this.category);

    console.log('customDefaultPlaceCategory.useDefault', this.customDefaultPlaceCategory);
    // if (!PlaceCategory.isIgDefaultCategory(this.category)) {
    if (!this.customDefaultPlaceCategory.useDefault) {
      // get selected custom category and bring back to calendar
      const selectedPlaceCategoryStr = localStorage.getItem(localStorageKeys.selectedPlaceCategory);

      const selectedCustomPlaceCategory = isJsonString(selectedPlaceCategoryStr)
        ? (JSON.parse(selectedPlaceCategoryStr) as PlaceType)
        : selectedPlaceCategoryStr;

      // menuType === 'custom' means this category is from URL, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
      if (this.menuType === 'custom' && typeof selectedCustomPlaceCategory !== 'string') {
        let categoryList = [];
        PlaceService.getAllSubCategories(
          selectedCustomPlaceCategory || this.initialCustomDefaultPlaceCategory.category,
          categoryList
        );
        this.actionCommand.queryCommand.categoryList = categoryList;
        // this.actionCommand.queryCommand.category = this.categoryId;
      } else {
        // else means it is from all place calendar
        this.actionCommand.queryCommand.categoryList =
          typeof selectedCustomPlaceCategory === 'string'
            ? null
            : selectedCustomPlaceCategory
              ? selectedCustomPlaceCategory.categoryList
              : null;
        this.category = 'All';
        this.actionCommand.queryCommand.category =
          typeof selectedCustomPlaceCategory === 'string'
            ? this.category
            : selectedCustomPlaceCategory
              ? selectedCustomPlaceCategory.title || this.category
              : this.category;
      }
    }
    console.log('category in back', this.category);
    console.log('actionCommand in back', this.actionCommand);

    // for custom place button
    if (this.categoryId === 'custom-places') {
      // for map view
      const currentCustomPlaceBtn = this.customPlaces.find((x) => x._id === this.menuType);
      console.log('currentCustomPlaceBtn ---', currentCustomPlaceBtn);

      if (currentCustomPlaceBtn) {
        this.actionCommand.queryCommand.customPlaceBtnText = currentCustomPlaceBtn.btnText;
      }
      this.router.navigateByUrl(
        getRouteUrl(routeConfigs.visitor.customPlace, {
          hubName: this.hubName,
          customPlaceBtnId: this.menuType,
        }),
        {skipLocationChange: this.noChangeUrlWhenRedirect}
      );
    } else {
      this.router.navigateByUrl(
        getRouteUrl(routeConfigs.visitor.placeCalendar, {
          hubName: this.hubName,
          category: this.menuType === 'custom' ? this.categoryId : this.category,
          menuType: this.menuType || (this.simpleMenu ? 'simple' : 'normal'),
        }),
        {skipLocationChange: this.noChangeUrlWhenRedirect}
      );
    }

    this.actionCommand.isEventCalendar = false;
    this.actionCommand.isMapView = false;
    this.actionCommand.queryCommand.limit = 16;
    this.actionCommand.queryCommand.isForMapView = null;
    this.visitorCalendarStore.actionCommand.next(this.actionCommand);
  }

  public pagingBack() {
    if (this.noMoreBack) {
      return;
    }

    this.paginationIndex--;
    let start = this.paginationPageLimit * this.paginationIndex;
    let end = start + this.paginationPageLimit;
    if (start <= 0) {
      start = 0;
      this.noMoreBack = true;
    }
    this.places = this.allPlaces.slice(start, end);
    this.showingCount = `${start + 1} - ${end}`;
    this.noMoreNext = false;
    this.fitBounds();
  }

  public pagingNext() {
    if (this.noMoreNext) {
      return;
    }

    this.paginationIndex++;
    let start = this.paginationPageLimit * this.paginationIndex;
    let end = start + this.paginationPageLimit;
    if (end >= this.allPlaces.length) {
      end = this.allPlaces.length;
      this.noMoreNext = true;
    }
    this.places = this.allPlaces.slice(start, end);
    this.showingCount = `${start + 1} - ${end}`;
    this.noMoreBack = false;
    this.fitBounds();
  }

  public resizeMap() {
    this.isMapFullSize = !this.isMapFullSize;
  }

  private getPlaceCategories(): Observable<any> {
    if (!VisitorDataCache.placeCategories || !VisitorDataCache.placeCategories.length) {
      return Observable.create((observable) => {
        this.visitorApiService.getPlaceCategories().subscribe((data) => {
          VisitorDataCache.placeCategories = data;
          observable.next(data);
          observable.complete();
        });
      });
    } else {
      return Observable.of(VisitorDataCache.placeCategories);
    }
  }

  private afterGotPlaces(data) {
    this.allPlaces = data;
    this.paginationIndex = 0;
    this.showingCount = null;

    if (data.length > this.paginationPageLimit) {
      let max = this.paginationPageLimit * (this.paginationIndex + 1);
      this.places = data.slice(0, max);
      this.noMoreNext = false;
      this.noMoreBack = true;
      this.showingCount = `${this.paginationPageLimit * this.paginationIndex + 1} - ${max}`;
    } else {
      this.places = data;
    }
    this.places.forEach((x) => {
      this.isInfoWindowsOpen.push(false);
    });
    this.fitBounds();
    setTimeout(() => {
      this.isLoading = false;
      this.isInitLoading = false;
      this.spinner.hide();
    });
  }

  private organizeMarkersForOverlapping() {
    this.markerOverlappings = [];
    this.mapMarkers.forEach((x, indexX) => {
      this.mapMarkers.forEach((y, indexY) => {
        if (x !== y) {
          if (this.isMarkersOverlapping(x, y)) {
            let toInsert = true;
            this.markerOverlappings.forEach((m) => {
              if (m.any((o) => o === indexX || o === indexY)) {
                if (!m.any((o) => o === indexX)) {
                  m.push(indexX);
                }
                if (!m.any((o) => o === indexY)) {
                  m.push(indexY);
                }
                toInsert = false;
              }
            });
            if (toInsert) {
              this.markerOverlappings.push([indexX, indexY]);
            }
          }
        }
      });
    });
  }

  private isMarkersOverlapping(marker1: AgmMarker, marker2: AgmMarker) {
    let zoom = this.map.zoom;
    let dis = GeoService.getDistanceFromLatLng(
      marker1.latitude,
      marker1.longitude,
      marker2.latitude,
      marker2.longitude
    );

    let metersPerPx = (156543.03392 * Math.cos((marker1.latitude * Math.PI) / 180)) / Math.pow(2, zoom);
    let pxDistance = dis / metersPerPx;

    return pxDistance <= 10;
  }

  private hideAllSingleInfoWindow() {
    if (this.isInfoWindowsOpen && this.isInfoWindowsOpen.length) {
      for (let i = 0; i < this.isInfoWindowsOpen.length; i++) {
        this.isInfoWindowsOpen[i] = false;
      }
    }
  }

  private hideAllInfoWindow() {
    this.hideAllSingleInfoWindow();
    this.showGroupInfowWindow = false;
  }

  public gotoDetails(id: string) {
    if (!id) return;

    this.visitorApiService.getPlaces(this.hubName, {id}).subscribe((places: HubPlace[]) => {
      if (!this.isMobile) {
        let actions = <PlaceDetailsModalActions>{
          confirm: (event: ButtonTriggerEvent, data: any) => {
          },
        };

        this.modalService.show({
          component: PlaceDetailsModalComponent,
          providers: [
            {provide: PlaceDetailsModalActions, useValue: actions},
            {provide: HubPlace, useValue: places[0]},
          ],
          panelClass: 'modal-fixed-top',
        });
      } else {
        this.showDetailModalForMobile(places[0], 'place');
      }
    });
  }

  public showDetailModalForMobile(item: any, displayingOn: string, isShowAddToTripBtn = false, index?: number) {
    let actions = <TripDetailModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
      },
    };
    this.modalService.show({
      component: TripDetailModalComponent,
      providers: [
        {provide: TripDetailModalActions, useValue: actions},
        {
          provide: TripDetailModalData,
          useValue: new TripDetailModalData(
            item,
            displayingOn,
            this.hubName,
            null,
            null,
            isShowAddToTripBtn,
            index
          ),
        },
      ],
      panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
    });
  }

  private fitBounds() {
    if (!this.places || !this.places.length) {
      return;
    }

    this.googleMapService.getGoogle().then(() => {
      this.latLngBounds = new google.maps.LatLngBounds();

      this.places.forEach((x) => {
        if (x.lat && x.lng) {
          this.latLngBounds.extend(new google.maps.LatLng(x.lat, x.lng));
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.map/visitor.place.map.component.ts